/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { AddFittingComponent } from '../add-fitting-size/add-fitting.component';
import { DialogBoxComponent } from '../../shared/dialog-box/dialog-box.component';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { ActionPageEnumDto, FittingDto, ActionTypeEnumDto } from 'api/models';
import { FittingsManagementService } from 'api/services';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fitting-state-approval',
  templateUrl: './fitting-state-approval.component.html',
  styleUrls: [
    '../fitting-state-management/fitting-state-management.component.css'
  ]
})
export class FittingStateApprovalComponent extends AddFittingComponent
  implements OnInit {

  columnHeader: any = {
    fittingEntryID: 'Fitting Entry ID',
    manufacturerName: 'Manufacturer Name',
    productLineName: 'ProductLine Name',
    longDescription: 'Long Description',
    fileName: 'File Name ',
    status: 'Status',
    requestBy: 'Request By',
    unitsName: 'Units Name'
  };

  ngOnInit() {
    this.actionPage = ActionPageEnumDto.Continue;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();

  }

  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    super(dialog, userHandlerService, fittingsManagementService, genericTableDataService,
      fittingSizeDataService, fittingSizeManagementService, authentificationService, loaderService);
  }

  getExistingFittingSizes(fitting: FittingDto) {

    super.getExistingFittingSizes(fitting, true);

  }
  getFittingsData() {
    this.loaderService.display(true);
    this.fittingsManagementService.getRecordsForApproval(
      {
        actionPageDto: this.actionPage
      }
    )
      .subscribe(result => {
        this.genericTableDataService.setTableDataList(result);
        this.loaderService.display(false);
      });
  }

  onRejectActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Reject action',
        comment: '',
        message: 'Do you want to reject this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'Reject');
  }

  onApproveActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Approve action',
        comment: '',
        message: 'Do you want to approve this fitting?',
        addComment: true
      }
    });
    this.handleActionButton(dialogRef, element, 'Approve');
  }


  handleActionButton(
    dialogRef: MatDialogRef<DialogBoxComponent, any>,
    element, actionType: string
  ) {
    const subscribeOk = dialogRef.componentInstance.okClickEvent.subscribe(
      () => {
        if (
          dialogRef.componentInstance.data.addComment &&
          dialogRef.componentInstance.data.comment !== '' &&
          dialogRef.componentInstance.data.comment !== undefined
        ) {
          switch (actionType) {
            case 'Approve':
              this.onApproveAction(element, dialogRef.componentInstance.data.comment);
              break;
            case 'Reject':
              this.onRejectAction(element, dialogRef.componentInstance.data.comment);
              break;
          }

        } else {
          this.fittingSizeManagementService.openSnackBar(
            'Add a comment before rejecting or approving a fitting'
          );
        }
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      subscribeOk.unsubscribe();
    });
  }

  onApproveAction(element: FittingDto, comment: string) {
    this.loaderService.display(true);
    let nextActionType: ActionTypeEnumDto;
    let isDiscontinued: boolean;
    switch (element.statusID) {
      case ActionTypeEnumDto.RequestToContinueFittingSendForApproval:
        isDiscontinued = false;
        nextActionType = ActionTypeEnumDto.ChangeToContinueApproved;
        break;
      case ActionTypeEnumDto.RequestToDiscontinueFittingSendForApproval:
        isDiscontinued = true;
        nextActionType = ActionTypeEnumDto.ChangeToDiscontinueApproved;
        break;
    }
    this.fittingsManagementService.updateFittingStatusAsync({
      userId: this.userHandlerService.getCurrentUserId(),
      bdToolId: element.bdToolID,
      actionTypeEnumDto: nextActionType,
      fittingEntryId: element.fittingEntryID,
      isDiscontinue: isDiscontinued,
      comment
    }).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Fitting has been approved succesfully'
      );
    });
  }

  onRejectAction(element: FittingDto, comment: string) {
    this.loaderService.display(true);
    let nextActionType: ActionTypeEnumDto;
    switch (element.statusID) {
      case ActionTypeEnumDto.RequestToContinueFittingSendForApproval:
        nextActionType = ActionTypeEnumDto.RequestToContinueFittingGotRejected;
        break;
      case ActionTypeEnumDto.RequestToDiscontinueFittingSendForApproval:
        nextActionType = ActionTypeEnumDto.RequestToDiscontinueFittingGotRejected;
        break;
    }
    this.fittingsManagementService.updateFittingStatusAsync({
      userId: this.userHandlerService.getCurrentUserId(),
      bdToolId: element.bdToolID,
      actionTypeEnumDto: nextActionType,
      fittingEntryId: element.fittingEntryID,
      comment
    }).subscribe(() => {
      this.getFittingsData();
      this.fittingSizeManagementService.openSnackBar(
        'Fitting has been rejected succesfully'
      );
    });
  }
}
